import React from "react";
import { motion } from "framer-motion";
import { Sparkles, UploadCloud, FileText, HelpCircle, ClipboardList, Award, Megaphone, Rocket, Library, Swords } from "lucide-react";

const ACTIONS = (hasCourses) => [
  { id: "create-course", label: "Create AI Course", desc: "Start a new video course", icon: Sparkles, color: "#3B82F6" },
  { id: "upload-video", label: "Upload Video", desc: hasCourses ? "Add a lecture to a course" : "Create a course first", icon: UploadCloud, color: "#A855F7" },
  { id: "generate-notes", label: "Generate Notes", desc: "AI notes from your video", icon: FileText, color: "#34D399" },
  { id: "create-quiz", label: "Create Quiz", desc: "AI or manual questions", icon: HelpCircle, color: "#FBBF24" },
  { id: "create-assignment", label: "Create Assignment", desc: "Set student homework", icon: ClipboardList, color: "#F472B6" },
  { id: "issue-certificate", label: "Issue Certificate", desc: "Reward a top student", icon: Award, color: "#22D3EE" },
  { id: "ai-marketing", label: "AI Marketing", desc: "Generate promo copy", icon: Megaphone, color: "#FB7185" },
  { id: "create-challenge", label: "AI Challenge Builder", desc: "Generate a 30-day roadmap", icon: Rocket, color: "#818CF8" },
  { id: "manage-resources", label: "Media Library", desc: "Add PDFs & YouTube links", icon: Library, color: "#2DD4BF" },
  { id: "configure-boss-battle", label: "Boss Battle", desc: "Capstone project + AI grading", icon: Swords, color: "#F59E0B" },
];

export default function CreatorQuickActions({ hasCourses, onAction }) {
  return (
    <div data-testid="creator-quick-actions">
      <h2 className="text-xl sm:text-2xl font-medium text-[#f7f8f8] mb-4">Quick Actions</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {ACTIONS(hasCourses).map((a, i) => (
          <motion.button
            key={a.id} onClick={() => onAction(a.id)} data-testid={`quick-action-${a.id}`}
            initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35, delay: i * 0.05 }}
            className="text-left rounded-2xl border border-white/[0.08] bg-[#131a29]/80 backdrop-blur-xl p-5 shadow-[0_8px_32px_rgba(0,0,0,0.12)] hover:-translate-y-1 hover:border-white/20 transition-[transform,border-color] duration-200"
          >
            <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-3" style={{ background: `${a.color}1a` }}>
              <a.icon className="w-5 h-5" style={{ color: a.color }} />
            </div>
            <p className="text-sm font-semibold text-[#f7f8f8]">{a.label}</p>
            <p className="text-[11px] text-[#8a8f98] mt-0.5">{a.desc}</p>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
